<template>
  <div class="toolbar column">
      <div class="columns">
        <div class="column" :class="blukActionsDropdown()" v-if="!isBimPlus">
          <div class="columns">
            <div v-if="['prefab-edit', 'po-edit', 'manager-edit-detailing', 'manager-edit-manufacturing'].includes(activeScreen)" class="bim-dropdown-create mt-3">
              <mf-multi-select v-if="addItemsOpts.length"
                track-by="type"
                label="label"
                placeholder="Add Items"
                :multiple="false"
                :options="addItemsOpts"
                :allow-empty="false"
                @select="(e) => fireEvent(e.event, false, e.optType)"
                :noDirtyEmit='true'
              ></mf-multi-select>
            </div>
            <div class="column is-narrow" v-if="tools?.isAddDeliveryBtn">
              <button
                class="button has-background-black-bis has-text-white has-text-weight-bold"
                @click="fireEvent('addDelivery', false)"
              >Add Delivery</button>
            </div>
            <div class="is-divider-vertical mx-0" v-if="tools?.isAddDeliveryBtn"></div>
            <div class="column" :class="activeScreen === 'shipping-card-edit' ? 'is-8 is-9-desktop bulk-dropdown' : '' ">
              <mf-multi-select v-if="actions?.length"
                :disabled="selectedAction?.name || fromDashBoard || permissionDisabled()"
                v-model="selectedAction"
                track-by="event"
                label="name"
                :placeholder="getBulkActionPlaceHolder"
                :multiple="false"
                :options="actions"
                :allow-empty="false"
                @select="fireEvent($event, true)"
                :selectedWorkstep="selectedWorkstep"
                :noDirtyEmit='true'
              ></mf-multi-select>
            </div>
          </div>
        </div>
        <div :class="!isBimPlus ? 'column is-offset-5 is-offset-2-desktop' : 'column'">
          <div class="columns">
            <div class="column" :class="isBimPlus ? 'pt-0' : ''">
              <div class="is-flex is-align-items-center" :class="isBimPlus ? 'is-justify-content-space-between' : 'is-justify-content-flex-end'">
                  <div class="bim-dropdown-create" v-if="$store.state.activeScreen === 'detailing'">
                    <mf-multi-select v-if="createOpts?.length"
                      track-by="type"
                      label="label"
                      placeholder="Create Order(s)"
                      group-values="val" group-label="key"
                      :multiple="false"
                      :options="createOpts"
                      :allow-empty="false"
                      @select="(e) => fireEvent(e.event, false, e.optType)"
                      :noDirtyEmit='true'
                    ></mf-multi-select>
                  </div>
                  <div class="is-divider-vertical" v-if="$store.state.activeScreen === 'detailing'"></div>
                  <div v-for="(button, idx) in toolButtons" :key="idx" class="toolbar-icon">
                    <div class="py-0 mr-2">
                      <template v-if="button.type === 'switch'">
                          <o-switch v-if="button.event === 'showCompletedItems'" v-model="completedItems"
                            name="showCompletedItems"
                            @change="fireEvent(button.event, false, showEmpty);">
                            <span class="has-text-black-bis is-size-3 is-italic has-text-weight-bold">
                              {{ button.label}}
                            </span>
                          </o-switch>
                          <o-switch v-else-if="button.event === 'showArchive'" v-model="showEmpty"
                            @change="fireEvent(button.event, false, showEmpty);">
                            <span class="has-text-black-bis is-size-3 is-italic has-text-weight-bold">
                              {{ button.label}}
                            </span>
                          </o-switch>
                      </template>
                      <template v-else-if="button.type === 'search'">
                        <search-bar v-bind:placeholder="placeholder" :shouldEmit="true" :searchValue="rowData.search" @search="(val) => fireEvent(button.event, false, val)"/>
                      </template>
                      <o-dropdown
                        v-else-if="button.options && routeParams.stage === button.showOptionsForStage"
                        :disabled="isButtonDisabled(button)"
                        position="bottom-left" aria-role="list">
                        <template #trigger>
                          <button class="button">
                            <i :class="button.icon"></i>
                          </button>
                        </template>
                        <o-dropdown-item
                          v-for="(opt, idx) in button.options"
                          :key="idx"
                          @click="fireEvent(button.event, false, opt.type)"
                          aria-role="listitem"
                        >
                          <span>{{ opt.label }}</span>
                        </o-dropdown-item>
                      </o-dropdown>
                      <button
                        v-else-if="showActionButtons"
                        @click="fireEvent(button.event, false)"
                        v-show="!showToolbarButtons(button)"
                        :disabled="disabledOnPermission(button) ||
                          (button.event === 'createBOMS' ? createBOMS : isButtonDisabled(button)
                        )"
                        v-tooltip="button.tooltip"
                        class="button"
                        :class="button.title ? 'has-background-black-bis has-text-white mr-3 has-text-weight-bold' : 'p-0'">
                        <i :class="button.icon" v-if="button.icon"></i>
                        <span v-else>{{ button.title }}</span>
                      </button>
                    </div>
                  </div>
                <div class="is-divider-vertical" v-if="toolButtons.length"></div>                 
                <div class="column" v-if="isBimPlus">
                  <div class="columns">
                    <div class="column is-3 pl-0">
                      <div v-if="$store.state.activeScreen === 'bimplus-additems'" class="buttons bimplus-button is-flex is-align-items-center">
                        <span class="is-size-3 has-text-black-bis mr-2">Add Objects:</span> 
                        <div>
                          <button v-if="!isSDS2" class="has-background-black-bis has-text-white button"  @click="fireEvent('group-bySelection')">
                            By Selection
                          </button>
                          <button class="has-background-black-bis has-text-white button" @click="fireEvent('group-by')">
                            By Object Group
                          </button>
                        </div>
                      </div>
                      <search-bar v-bind:placeholder="placeholder"
                          v-if="!tools.hideSearchBar">
                      </search-bar>
                    </div>
                    <div class="column has-text-centered is-6">
                      <div v-if="(tab === 'items' && rowData.isCutOrder) || $store.state.activeScreen === 'bim-create'">
                        <Pagination :total="paginationTotal"
                          :initialValue="rowData.page"
                        @pagination="(val) =>fireEvent('itemPagination', false, val)"/>
                      </div>
                    </div>
                    <div class="column is-3 pr-0">
                      <div v-if="['bim-create', 'bimplus-additems'].includes($store.state.activeScreen) && disableBOMCreation" class="is-pulled-right">
                        <o-checkbox v-model="createBOM" :disabled="isSDS2" @update:modelValue="fireEvent()">
                          Allocate Materials/Create Material Orders
                        </o-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else :class="tools.advancedSearch && skipAdvanceSearch ? 'search-root' : ''">
                  <search-bar v-bind:placeholder="placeholder"
                    :isAdvanced="tools.advancedSearch && skipAdvanceSearch"
                    v-if="!tools.hideSearchBar">
                  </search-bar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import {
  computed, reactive, toRefs, onMounted, watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  isFunction, isEmpty, isObject, some, get, set, groupBy, map,
} from 'lodash';
import { ModalProgrammatic } from '@oruga-ui/oruga-next';
import MfMultiSelect from '@/components/abstract/MfMultiSelect.vue';
import SearchBar from '@/components/SearchBar.vue';
import Pagination from '@/components/Pagination.vue';
import PermissionMixin from '@/components/mixins/PermissionMixin';
import PrefabsMixin from '@/components/mixins/PrefabsMixin';
import screens from '@/constants';
import SelectProject from '@/components/modals/SelectProject.vue';
import Projects from '@/models/Projects';

export default {
  name: 'MfToolbar',
  components: {
    MfMultiSelect,
    SearchBar,
    Pagination
  },
  props: {
    tools: Object,
    purpose: {
      type: String,
      default: () => '',
    },
    poMaterials: {
      type: Array,
      default: () => [],
    },
    showArchive: {
      type: Boolean,
      default: () => false,
    },
    orderStage: {
      type: String,
      default: () => '',
    },
    isKitOrder: Boolean,
    rowData: {
      type: Object,
      default: () => {},
    },
    tab: {
      type: String,
    },
    isPartQtyUpdated: Boolean,
    selectedWorkstep: {},
    notesUpdated: Boolean,
    vendorUpdated: Boolean,
    isBimPlus: Boolean,
    isSDS2: {
      type: Boolean,
      default: false,
    },
    project: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const { getPermissionValues } = PermissionMixin();
    const { createBomAndPR } = PrefabsMixin();
    const { activeScreen } = store.state;
    const state = reactive({
      selectedAction: null,
      columnChooserModal: false,
      showEmpty: props.showArchive,
      routeParams: !isEmpty(route.params)
        ? route.params : { stage: route.path.split('/').pop() },
      createBOMS: true,
      showActionButtons: false,
      labelType: '',
      createBOM: props.isSDS2,
      selectedModel: {}
    });
    const clearAction = () => {
      state.selectedAction = null;
    };
    const disableBOMCreation = computed(() => {
      return props.isSDS2 ? true : get(props, 'project.projectSettings[0].bimplusBindings.bimplusProperties[0].value', false);
    })
    const actions = computed(() => {
      if (isFunction(props.tools.bulkActions)) {
        return props.tools.bulkActions(
          state.routeParams.stage,
          props.orderStage,
          route.params,
          route.path,
          props.rowData,
        );
      }
      return props.tools.bulkActions || [];
    });
    const createOpts = computed(() => {
      if (isFunction(props.tools.bulkCreateOptions)) {
        let bulkCreateOpts = groupBy(props.tools.bulkCreateOptions(state.routeParams.stage), 'group');
        bulkCreateOpts = map(bulkCreateOpts, (val, key) => ({
          val,
          key,
        }));
        return bulkCreateOpts;
      }
    });
    const addItemsOpts = computed(() => {
      if (isFunction(props.tools.bulkCreateOptions)) return props.tools.bulkCreateOptions(state.routeParams, props, route, store.state.userData.viewOnlyMember);
      return props.tools.bulkCreateOptions || [];
    });
    const placeholder = computed(() => {
      const placeholderVal = {
        schedule: 'Search Activities',
        forms: 'Search Forms',
        default: 'Search',
        inventory: 'Search Items',
      };
      return placeholderVal[activeScreen] || placeholderVal.default;
    });

    const toolButtons = computed(() => {
      if (isFunction(props.tools.buttons)) {
        let isPropDisabled = false;
        if (['manager-edit-manufacturing', 'cut-edit-manufacturing'].includes(activeScreen)) {
          isPropDisabled = props.rowData.disableReserveBtn || false;
        }
        return props.tools.buttons(state.routeParams.stage, props.poMaterials, isPropDisabled, props.rowData?.isCutOrder);
      }
      return props.tools.buttons || [];
    });
    const fromDashBoard = computed(() => route.query.fromDashBoard === 'true');
    const showToolbarButtons = (button) => {
      if (isFunction(props.tools.showButtons)) {
        return props.tools.showButtons(route.params, button);
      }
      return props.isKitOrder || false;
    };
    const fireEvent = async (eventHandler, setBulkAction, optType) => {
      clearAction();
      if (eventHandler === 'createBIMOrder') {
        ModalProgrammatic.open({
          component: SelectProject,
          props: {
            title: 'Create Order(s) from BIMPLUS Object Groups',
            description:'To add model objects to orders, select Manufacton project, then select BIMPLUS model',
            isBimplus: true,
          },
          trapFocus: true,
          canCancel: false,
          rootClass: 'modal-xs',
          events: {
            'selected-model': async (e) => {
              store.commit('setSelectedProject', e);
              router.push({
                name: 'bimplus-view',
                params: {
                  module: 'viewer',
                  projectId: e._id,
                },
                query: {
                  from: 'createOrder'
                }
              });
            }
          },
        })
      }
      if (eventHandler === 'fromBIMPLUS') {
        const selectedProject = await Projects.get(props.rowData.project._id);
        const isGuidItems = some(props.rowData.items, (item) => item.hasGuid);
        
        if (isGuidItems && selectedProject.projectSettings[0].bimplusSync?.team?.id) {
          state.selectedModel = selectedProject.projectSettings[0].bimplusSync?.models.find((model) => model.id === props.rowData.modelId);
          console.log('-------->topologyID', state.selectedModel);
          router.push({
            name: 'bimplus-additems',
            params: {
              projectId: props.rowData.project._id,
              cardId: props.rowData._id,
            },
            query: {
              topologyId: state.selectedModel.topologyId // selectedModel.topologyId
            }
          });
        } else {
          router.push({
            name: 'bimplus-view',
            params: {
              module: 'viewer',
              projectId: props.rowData.project._id,
            },
            query: {
              from: 'addModelObjects',
              cardId: props.rowData._id
            }
          });
        }
      }
      state.selectedAction = setBulkAction ? eventHandler : null;
      if (eventHandler?.event === 'bulkQrPrint') {
        if (!state.labelType && activeScreen !== 'inventory') {
          state.selectedAction.name = 'Print QR Labels (Orders And Items)';
        }
      }
      const handler = setBulkAction ? eventHandler : {
        event: eventHandler,
        type: eventHandler,
        optType: optType,
        nonBulkAction: true,
        createBOM: state.createBOM,
      };
      if (handler.event === 'itemPagination' && props.rowData.search) {
        handler.optType.search = props.rowData.search;
      }
      
      
      else emit('event', handler);
    };

    const paginationTotal = computed(() => {
      if (props.tab === 'items' && props.rowData.isCutOrder) {
        return Math.ceil(props.rowData.totalCutItems/50);
      } else {
        return Math.ceil(props.rowData.length/25);
      }
    })

    const isButtonDisabled = (button) => {
      if (state.selectedAction !== null) return true;
      if (isFunction(button.isDisabled)) {
        // in list view, if qty is updated - enable the button
        if (['assemblies', 'cutParts'].includes(activeScreen)) {
          return button.isDisabled(props.isPartQtyUpdated, props.notesUpdated);
        }
        return button.isDisabled(state.routeParams, props, props.isPartQtyUpdated || props.vendorUpdated);
      }
      if(store.state.userData.viewOnlyMember && ['addNew', 'excelImport', 'excelExport'].includes(button.event)) return true;
      let permissionRes = false;
      if (isObject(button.acl)) {
        permissionRes = getPermissionValues({ ...button.acl, project: { _id: route.path.split('/')[2] } }, false);
      }
      return button.isDisabled || permissionRes || false;
    };

    const getPermissionModule = computed(() => {
      const moduleMap = {
        inventory: 'inventory',
        'shipping-order-view': 'shipping',
        assemblies: 'app&projects',
        parts: 'app&projects',
      };
      if (moduleMap[activeScreen]) return moduleMap[activeScreen];
      return activeScreen;
    });

    const disabledOnPermission = ((button) => {
      if (getPermissionModule.value && button.permissionType) {
        const value = getPermissionValues({
          permissionModule: getPermissionModule.value,
          type: button.permissionType,
        });
        if (value) return true;
      }
      return false;
    });

    const isBOMDisabled = async () => {
      const card = await createBomAndPR(props.rowData);
      state.createBOMS = card?._bomCreated;
    };

    onMounted(async () => {
      // using a flag to enable the toolbar action buttons bcoz the
      // flyout was taking too much time to showup on clicking the icon
      // due to the v-tooltip
      state.showActionButtons = true;
      if (some(toolButtons.value, (button) => button.event === 'createBOMS')) isBOMDisabled();
    });
    const getDropClass ={
      'mm-sourcing': 'is-4 bulk-action-width is-4-desktop',
      'shipping-card-edit': 'is-2 is-2-fullhd',
    }
    const blukActionsDropdown = () => { 
     return getDropClass[activeScreen] || 'is-3 is-3-fullhd is-4-desktop';}
    const permissionModule = () => {
      const res = get(screens[store.state.activeScreen], 'permissionModule', '');
      return res;
    };

    const permissionDisabled = () => getPermissionValues({
      permissionModule: permissionModule(),
      type: 'bulkActions',
    });

    const labelTypeMap = {
      order: 'Print QR Labels (Orders Only)',
      item: 'Print QR Labels (Items Only)',
      both: 'Print QR Labels (Orders And Items)'
    };

    watch(
      () => store.state.qrScan.labelType,
      (newVal) => {
        state.labelType = newVal;

        if (!state.selectedAction) return;

        state.selectedAction.name = labelTypeMap[newVal] || state.selectedAction.name;
      }
    );

    const completedItems = computed({
      get: () => {
        return !!props?.rowData?.showCompletedItems;
      },
      set: (val) => {
        set(props.rowData, 'showCompletedItems', val ? 1 : 0)
      }
    })
    const getBulkActionPlaceHolder = computed(() => {
      if (props.tab === 'items' && activeScreen === 'shipping-card-edit') return 'Add Items';      
      return 'Bulk Actions'
    })

    const skipAdvanceSearch = computed(() => {
      // used in situation where the single cols file used for multiple screen
      return !['schedule'].includes(store.state.activeScreen)
    })
    return {
      ...toRefs(state),
      fireEvent,
      clearAction,
      actions,
      showToolbarButtons,
      isButtonDisabled,
      toolButtons,
      getPermissionModule,
      disabledOnPermission,
      placeholder,
      blukActionsDropdown,
      fromDashBoard,
      permissionDisabled,
      permissionModule,
      completedItems,
      activeScreen,
      getBulkActionPlaceHolder,
      createOpts,
      paginationTotal,
      addItemsOpts,
      disableBOMCreation,
      skipAdvanceSearch
    };
  },
};
</script>
<style scoped>
::v-deep(.searchbar) {
  flex: 1;
}
/* added below class to make the bulk action dropdown non-scaling for different resolution */
.bulk-action-width {
  width: 400px !important;
}

</style>
